import React from "react";
import { useCookieConsent } from "@/context/CookieContext";

export default function CookieBanner() {
  const { showBanner, acceptAll, rejectNonEssential, openPreferences } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie preferences"
      className="fixed inset-x-0 bottom-0 z-50 bg-[#0A1F44]/97 backdrop-blur-sm text-white"
      style={{ boxShadow: "0 -1px 0 0 rgba(212, 175, 55, 0.5)" }}
    >
      <div className="evg-container py-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="flex-1 max-w-3xl">
            <div className="evg-overline-gold mb-2">Cookie Preferences</div>
            <p className="text-[13px] text-white/75 leading-relaxed font-light">
              We use cookies and similar technologies to improve website performance, understand
              visitor behaviour and enhance your browsing experience. You can accept all cookies,
              reject non-essential cookies or manage your preferences at any time.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 lg:flex-nowrap">
            <button
              type="button"
              onClick={openPreferences}
              data-testid="cookie-manage-preferences"
              className="text-[11px] uppercase tracking-[0.24em] font-medium text-white/70 hover:text-white transition-colors underline-offset-4 hover:underline"
            >
              Manage Preferences
            </button>
            <button
              type="button"
              onClick={rejectNonEssential}
              data-testid="cookie-reject"
              className="text-[11px] uppercase tracking-[0.24em] font-medium text-white/70 hover:text-white transition-colors underline-offset-4 hover:underline"
            >
              Reject Non-Essential
            </button>
            <button
              type="button"
              onClick={acceptAll}
              data-testid="cookie-accept-all"
              className="text-[11px] uppercase tracking-[0.24em] font-medium px-6 py-3 bg-[#D4AF37] text-[#0A1F44] hover:bg-[#c4a032] transition-colors whitespace-nowrap"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
